import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Spin, Tooltip } from "antd";
import { FC } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { HostCfgWithStatus } from "./importConnectionTest";

interface Props {
    deviceType: string;
    device: HostCfgWithStatus;
    showSections: (device: HostCfgWithStatus) => void;
}

export const ImportDeviceTableRow: FC<Props> = ({ deviceType, device, showSections }) => {


    return (
        <tr>
            <td>{device.label}</td>
            <td>{deviceType}</td>
            <td>
                {
                    device.status === "unknown"
                        ? <Tooltip title="Connection test is running"><div><Spin indicator={<LoadingOutlined className="xm-connection-status" spin />} /></div></Tooltip>
                        : device.status === "failure"
                            ? <FaTimes className="xm-connection-status" color="darkred" />
                            : <FaCheck className="xm-connection-status" color="darkgreen" />
                }
            </td>
            <td className="information-cell" onClick={() => { showSections(device); }}><InfoCircleOutlined></InfoCircleOutlined></td>
        </tr>
    );
};